import { render, staticRenderFns } from "./beneficiosForm.vue?vue&type=template&id=37d2346b&scoped=true&"
import script from "./beneficiosForm.vue?vue&type=script&lang=js&"
export * from "./beneficiosForm.vue?vue&type=script&lang=js&"
import style0 from "./beneficiosForm.vue?vue&type=style&index=0&id=37d2346b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d2346b",
  null
  
)

export default component.exports